import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ServiceRegions from './ServiceRegions';

async function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Service Regions',
    component: <AdminLayout><ServiceRegions /></AdminLayout>,
  };
}

export default action;
